import {Controller} from "react-hook-form";
import React from "react";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerControl.scss' ;

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { enGB } from 'date-fns/locale'
registerLocale('en', enGB)

const DatePickerControl = ({ name, control,  placeHolder, validate, readOnly, showTimeInput, showTimeSelect, dateFormat }) =>
{
    const df = dateFormat === undefined ? "dd/MM/yyyy" : dateFormat ;

    return (
        <Controller
            name={name}
            control={control}
            rules={{ validate: validate}}
            render={({field:{ onChange, value }}) =>
            {
                const onc = (e) =>
                {
                    console.log ( e ) ;
                    onChange ( e ) ;
                }

                return (
                    <div className='date-wrapper'>
                        <DatePicker
                            placeholderText={placeHolder}
                            selected={value}
                            onChange={onc}
                            disabled={readOnly}
                            wrapperClassName="datePicker"
                            dateFormat={df}
                            dateFormatCalendar="MMMM"
                            showYearDropdown
                            showTimeInput={showTimeInput}
                            showTimeSelect={showTimeSelect}
                            yearDropdownItemNumber={30}
                            scrollableYearDropdown
                            dataTimezone='local'
                            displayTimezone='local'
                            locale='en'
                        />
                    </div>
                )
            }
        }
        />
    )
}

export default DatePickerControl ;
